package cz.lhoracek.mapl.ui.navigation

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

class NavigationController {
    private val stack = mutableStateListOf<Screen>(Screen.Home)

    val current: Screen get() = stack.last()
    val canGoBack: Boolean get() = stack.size > 1
    val depth: Int get() = stack.size

    fun navigate(screen: Screen) {
        stack.add(screen)
    }

    fun back(): Boolean {
        return if (stack.size > 1) {
            stack.removeLast()
            true
        } else {
            false
        }
    }

    fun backTo(screen: Screen) {
        while (stack.size > 1 && stack.last() != screen) {
            stack.removeLast()
        }
    }
}
